exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#layout td {\n  padding: 5px; }\n\n#layout {\n  width: 400px; }\n\n.month {\n  text-align: right;\n  color: #878787;\n  font-family: futura; }\n\n#layout mat-progress-bar {\n  height: 10px;\n  border-radius: 5px; }\n\n:host /deep/ .mat-progress-bar-fill {\n  background-color: #878787; }\n\n:host /deep/ .mat-progress-bar-fill::after {\n  background-color: #878787; }\n\n:host /deep/ .mat-progress-bar-buffer {\n  background-color: transparent; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Workspace/hyblab-migration/src/app/months-value/months-value.component.scss
// module id = ../../../../../src/app/months-value/months-value.component.scss
// module chunks = main